import type {Icon} from '@primer/octicons-react'

import {CustomIcon} from './CustomIcon'

export const ClockHandsIcon: Icon = props => {
  return (
    <CustomIcon {...props}>
      <path d="M8.5 4.75v2.992l2.028.812a.75.75 0 0 1-.557 1.392l-2.5-1A.751.751 0 0 1 7 8.25v-3.5a.75.75 0 0 1 1.5 0Z" />
    </CustomIcon>
  )
}
